<div class="mobile-table-container">
  <table mat-table [dataSource]="councils" multiTemplateDataRows class="mat-table mobile-responsive-table" [class.is_mobile]="isMobile">
    <ng-container matColumnDef="certifiedHubMedical">
      <th mat-header-cell *matHeaderCellDef class="certifiedHubMedicalIcon"></th>
      <td mat-cell *matCellDef="let element" class="certifiedHubMedicalIcon">
        <img [src]="element.certifiedHubMedical ? 'assets/icons/icon_certificado_concedido.svg' :
        'assets/icons/icon_certificado_ausente.svg'"
          [matTooltip]="element.certifiedHubMedical ? 'Certificado Hub Medical' : 'Não certificado' " width="24px" alt="">
      </td>
    </ng-container>

    <ng-container matColumnDef="councilGroup">
      <th mat-header-cell *matHeaderCellDef>Conselho</th>
      <td mat-cell *matCellDef="let element" (click)="expandedElement = expandedElement === element ? null : element">
        <!-- <span class="mobile-label">Conselho</span> -->
        {{ element.councilGroup }}
      </td>
    </ng-container>

    <ng-container matColumnDef="councilInscriptionNumber">
      <th mat-header-cell *matHeaderCellDef>Inscrição</th>
      <td mat-cell *matCellDef="let element" (click)="expandedElement = expandedElement === element ? null : element">
        <!-- <span class="mobile-label">Inscrição</span> -->
        {{ element.councilInscriptionNumber }}
      </td>
    </ng-container>

    <ng-container matColumnDef="district">
      <th mat-header-cell *matHeaderCellDef>Estado</th>
      <td mat-cell *matCellDef="let element" (click)="expandedElement = expandedElement === element ? null : element">
        <!-- <span class="mobile-label">Inscrição</span> -->
        {{ element.district }}
      </td>
    </ng-container>

    <ng-container matColumnDef="expand">
      <th mat-header-cell *matHeaderCellDef aria-label="row actions" class="col-actions">
      </th>
      <td mat-cell *matCellDef="let element" class="col-actions">
        @if(!element.certifiedHubMedical){
        <button mat-icon-button (click)="editCouncil(element)">
          <mat-icon>edit</mat-icon>
        </button>
        } @if(!element.councilProfession || element.councilProfession.length <= 0 || !element.certifiedHubMedical ){
          <button mat-icon-button (click)="deleteCouncil(element.id)">
          <mat-icon>delete</mat-icon>
          </button>
          }


      </td>
    </ng-container>

    <ng-container matColumnDef="expandedDetail">
      <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumnsCouncils.length" style="padding: 2px">
        <div class="element-detail">
          <div class="council">
            <div class="councilDetails">
              <span class="label" class="label">Primeira Inscrição na UF:
              </span>
              {{ element.firstInscriptionUF | date : "dd/MM/yyyy " }}<br />
              <span class="label">Inscrição no Conselho:</span>
              {{ element.councilInscriptionDate | date : "dd/MM/yyyy " }}<br />
              <span class="label">Status no Consulado:</span>
              {{ element.councilStatus }}<br />
              <span class="label">Ativo:</span>
              {{ element.active ? "Sim" : "Não" }}<br />
            </div>
            <div>
              <app-council-profession style="width: 100%" [councilProfessions]="element.councilProfession"
                [councilId]="element.id" [councilGroup]="element.councilGroup"></app-council-profession>
            </div>
          </div>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumnsCouncils" class="mat-header-row"></tr>
    <tr mat-row *matRowDef="let element; columns: displayedColumnsCouncils" class="mat-row"
      [class.expanded-row]="expandedElement === element"></tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
  </table>
</div>
<div>
  <br />
  <button mat-flat-button (click)="createCouncil(null)">Adicionar Conselho</button>
</div>